export const GolonganDarahSurat = () => ['A', 'B', 'AB', 'O', 'Tidak Diketahui']